import React from "react";
import { ForceRedirect } from "../../../../components";

const HomePage = () => {
    return <ForceRedirect uri="https://www.caixaseguradora.com.br/Paginas/home-geral.aspx" />;
};

HomePage.propTypes = {};

export default HomePage;
